module.exports = __webpack_public_path__ + "img/main-summer.b782e27e.jpg";